export const AddOn = {
  // Accounting
  EXACT_ONLINE: 10,
  SNELSTART: 20,
  EXACT_GLOBE: 30,
  UNIT_4: 40,
  YUKI: 60,
  TWINFIELD: 70,
  VISMA: 80,
  E_ACCOUNTING: 110,

  // WeighingBridge
  PFISTER: 50,

  // BusinessInfo
  KVK: 90,
  RDW: 91,

  // E-invoice
  E_INVOICE: 100,

  // Routing
  PTV: 120,
} as const

export type AddOnType = typeof AddOn[keyof typeof AddOn]

export default AddOn
